var map = {
	".": 1651,
	"./": 1651,
	"./Header": 9567,
	"./Header.tsx": 9567,
	"./Landing": 3709,
	"./Landing.tsx": 3709,
	"./index": 1651,
	"./index.tsx": 1651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9725;